import './App.css';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { useState, useEffect, useCallback } from 'react';
import Login from './pages/Login/Login';
import Dashboard from './pages/Dashboard/Dashboard';
import { getValidAdminToken, adminLogout, clearAdminLocalStorage, clearAllLocalStorage, debugLocalStorage, checkRemainingAdminData } from './services/auth/authManager';
import { setupPermissionErrorListener } from './services/utils/permissionErrorHandler';

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  // Proper token validation with expiration check
  const checkForToken = useCallback(() => {
    const token = getValidAdminToken(); // This checks expiration too
    console.log('App: Checking for valid token:', token ? 'Valid token exists' : 'No valid token (missing or expired)');
    setIsAuthenticated(!!token);
    return !!token;
  }, []);

  useEffect(() => {
    console.log('App component mounted');
    
    // Add global debugging functions to window object
    window.adminLogout = adminLogout;
    window.clearAdminLocalStorage = clearAdminLocalStorage;
    window.clearAllLocalStorage = clearAllLocalStorage;
    window.debugLocalStorage = debugLocalStorage;
    window.checkRemainingAdminData = checkRemainingAdminData;
    
    // Add a comprehensive debug function
    window.debugAuthState = () => {
      console.log('=== Auth State Debug ===');
      console.log('Is authenticated:', isAuthenticated);
      console.log('Is loading:', isLoading);
      debugLocalStorage();
      checkRemainingAdminData();
      console.log('=== End Auth State Debug ===');
    };
    
    // Initial token check
    checkForToken();
    setIsLoading(false);

    // Listen for auth events
    const handleAuthEvent = () => {
      console.log('Auth event received');
      checkForToken();
    };

    // Listen for various logout events
    window.addEventListener('token-expired', handleAuthEvent);
    window.addEventListener('logout', handleAuthEvent);
    window.addEventListener('admin-logout', handleAuthEvent);

    // Set up global permission error listener
    const cleanupPermissionListener = setupPermissionErrorListener();

    return () => {
      window.removeEventListener('token-expired', handleAuthEvent);
      window.removeEventListener('logout', handleAuthEvent);
      window.removeEventListener('admin-logout', handleAuthEvent);
      if (cleanupPermissionListener) {
        cleanupPermissionListener();
      }
    };
  }, [checkForToken]);

  if (isLoading) {
    return <div className="loading">Loading...</div>;
  }

  return (
    <Router>
      <Routes>
        <Route
          path="/login"
          element={
            isAuthenticated ? (
              <Navigate to="/dashboard" replace />
            ) : (
              <Login setIsAuthenticated={setIsAuthenticated} />
            )
          }
        />
        <Route
          path="/dashboard/*"
          element={
            isAuthenticated ? (
              <Dashboard setIsAuthenticated={setIsAuthenticated} />
            ) : (
              <Navigate to="/login" replace />
            )
          }
        />
        <Route
          path="/"
          element={
            <Navigate to={isAuthenticated ? "/dashboard" : "/login"} replace />
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
